module.exports = __webpack_public_path__ + "img/close-circle-fill-red.4109df69.svg";